import React, { Component } from 'react';
import ToggleButton from 'react-toggle-button'
import s from '../../services/allservices.jsx'
import { connect } from 'react-redux'
import * as actions from '../../actions/actions.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import LoaderSmall from "../loader/loader.jsx"
import $ from "jquery"
const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        alertState: state.getAlertReducer.alertState,
        cardState: state.getCardReducer.cardState

    })
const mapDispatchToProps = dispatch =>
    ({
        fetchAlertState(cardDetailsId) {
            dispatch(
                actions.getAlertAction(cardDetailsId)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
    })
const JSEncrypt = window.JSEncrypt
class MangeAlert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardDetailsId: 1,
            thresholdAmount: '',
            thresholdType: "G",
            alertEmailId: '',
            value: '',
            value1: '',
            serv: '',
            selectedCard: [],
            loader: false,
            correctEmail: true,
            correctamount: true,
        }


    }
    handleBasic = (astate) => {
        let detail = document.getElementById(astate.alertId + "1")
        detail.style.display = "none"

        let edit = document.getElementById(astate.alertId + "2")
        edit.style.display = "block"
        document.getElementById(astate.alertId + "cancel").style.display = "block"
        document.getElementById(astate.alertId + "edit").style.display = "none"
        this.setState({
            active: astate.active,
            alertEmailId: astate.alertEmailId,
            alertId: astate.alertId,
            alertName: astate.alertName,
            alertType: astate.alertType,
            alertValuesSet: astate.alertValuesSet,
            cardDetailsId: astate.cardDetailsId,
            contactNumber: astate.contactNumber,
            cutOverTime: astate.cutOverTime,
            merchantCategoryCodes: astate.merchantCategoryCodes,
            thresholdAmount: astate.thresholdAmount,
            thresholdType: astate.thresholdType,
            timezone: astate.timezone,
            useContactNumber: astate.useContactNumber,
            useMobilePush: astate.useMobilePush
        })
    }

    handleCancel = (alertid) => {

        let edit = document.getElementById(alertid + "2")
        edit.style.display = "none"

        let detail = document.getElementById(alertid + "1")
        detail.style.display = "block"

        document.getElementById(alertid + "cancel").style.display = "none"
        document.getElementById(alertid + "edit").style.display = "block"
    }

    handleChange = (event, index, value) => this.setState({ thresholdType: value }, () => { });
    onchangeEmail = (e, value) => {
        
        if (e.target.name === "alertEmailId" && value.length !== 0) {
            var eventVal= e.target.value
            this.setState({
                eventId:e.target.id
            },()=>{
                if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(eventVal)) {
                this.setState({
                    correctEmail: true,
                    alertEmailId: value,

                })
            } else {
                this.setState({
                    correctEmail: false,

                })
            }
            })
            
        }
    }
   
    onChangeAmount = (e, value) => {
        if (e.target.name === "thresholdAmount" && value.length !== 0) {
            var eventVal2= e.target.value
            this.setState({
                eventId2:e.target.id
            },()=>{
                if (/^(\d+)?([.]?\d{0,2})?$/.test(eventVal2)) {
                    this.setState({
                        correctamount: true,
                        thresholdAmount: value,
        
                    })
                }
                else {
                    this.setState({
                        correctamount: false,
        
                    })
                }
            })
            
           
        }
        // else {
        //     this.setState({
        //         correctamount: false,

        //     })
        // }

    }

    componentDidMount() {

        const { publicKey, alertState } = this.props

        this.setState({
            loader: false,
            cardDetailsId: this.props.cardState.body[0].cardDetailsId,

        })
        

        // document.getElementsByClassName("editmodal").style.display="none"

        this.props.fetchAlertState(this.props.cardState.body[0].cardDetailsId)

        let _this = this
        // setTimeout(function () {
        //     if (publicKey.status === 200) {
        //         const public_Key = publicKey.body.publickey;
        //         let encrypt = new JSEncrypt();
        //         encrypt.setPublicKey(public_Key);


        //         const state = {
        //             applicationId: "gmcabs",
        //             accountId: encrypt.encrypt(localStorage.getItem("accountId"))
        //         }
        //         _this.props.fetchCard(state)

        //     }
        // }, 500);
        // alertState.body.map((value,i)=>{
        //     document.getElementById(alertState.body[i].alertId+"2").style.display="none"
        // })
    }

    handleSubmit = (altstate) => {
        const { correctamount, correctEmail } = this.state
        if (correctamount === false) {
            this.setState({
                correctamount: false,
            })
        }
        else if (correctEmail === false) {
            this.setState({
                correctEmail: false,
            })
        } else {
            let _this = this
            var handleActive;
            if (altstate.active === true) {
                handleActive = false
            }
            else {
                handleActive = true
            }
            if (altstate.alertValuesSet === false) {
               
                let state = {
                    active: true,
                    alertEmailId: this.state.alertEmailId || altstate.alertEmailId,
                    alertId: altstate.alertId,
                    alertName: altstate.alertName,
                    alertType: altstate.alertType,
                    alertValuesSet: altstate.alertValuesSet,
                    cardDetailsId: altstate.cardDetailsId,
                    contactNumber: altstate.contactNumber,
                    cutOverTime: altstate.cutOverTime,
                    merchantCategoryCodes: altstate.merchantCategoryCodes,
                    thresholdAmount: this.state.thresholdAmount || altstate.thresholdAmount,
                    thresholdType: this.state.thresholdType || altstate.thresholdType,
                    timezone: altstate.timezone,
                    useContactNumber: altstate.useContactNumber,
                    useMobilePush: altstate.useMobilePush
                }
                // var serv1 = ''
                // if (altstate.alertType === "DP") {
                //     serv1 = s.deb_txnpost_alert

                // }
                // else if (altstate.alertType === "CP") {
                //     serv1 = s.cdt_txnpost_alert

                // }
                // else if (altstate.alertType === "BT") {
                //     serv1 = s.card_bal_alert
                // }
                // else if (altstate.alertType === "NSF") {
                //     serv1 = s.insuf_bal_alert
                // }
                // else {
                //     serv1 = s.other_alert
                // }

                let token = "Token " + localStorage.getItem('token')

                fetch(s.other_alert, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.props.fetchAlertState(altstate.cardDetailsId);

                            let edit = document.getElementById(altstate.alertId + "2")
                            edit.style.display = "none"

                            let detail = document.getElementById(altstate.alertId + "1")
                            detail.style.display = "block"

                            document.getElementById(altstate.alertId + "cancel").style.display = "none"
                            document.getElementById(altstate.alertId + "edit").style.display = "block"
                        } else {

                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })

            }

            else {
              
                let state = {
                    active: altstate.active,
                    alertEmailId: this.state.alertEmailId || altstate.alertEmailId,
                    alertId: altstate.alertId,
                    alertName: altstate.alertName,
                    alertType: altstate.alertType,
                    alertValuesSet: altstate.alertValuesSet,
                    cardDetailsId: altstate.cardDetailsId,
                    contactNumber: altstate.contactNumber,
                    cutOverTime: altstate.cutOverTime,
                    merchantCategoryCodes: altstate.merchantCategoryCodes,
                    thresholdAmount: this.state.thresholdAmount || altstate.thresholdAmount,
                    thresholdType: this.state.thresholdType || altstate.thresholdType,
                    timezone: altstate.timezone,
                    useContactNumber: altstate.useContactNumber,
                    useMobilePush: altstate.useMobilePush
                }
                // var serv1 = ''
                // if (altstate.alertType === "DP") {
                //     serv1 = s.deb_txnpost_alert

                // }
                // else if (altstate.alertType === "CP") {
                //     serv1 = s.cdt_txnpost_alert

                // }
                // else if (altstate.alertType === "BT") {
                //     serv1 = s.card_bal_alert
                // }
                // else if (altstate.alertType === "NSF") {
                //     serv1 = s.insuf_bal_alert
                // }
                // else {
                //     serv1 = s.other_alert
                // }

                let token = "Token " + localStorage.getItem('token')

                fetch(s.other_alert, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.props.fetchAlertState(altstate.cardDetailsId);

                            let edit = document.getElementById(altstate.alertId + "2")
                            edit.style.display = "none"

                            let detail = document.getElementById(altstate.alertId + "1")
                            detail.style.display = "block"

                            document.getElementById(altstate.alertId + "cancel").style.display = "none"
                            document.getElementById(altstate.alertId + "edit").style.display = "block"
                        } else {

                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })
            }
        }
    }

    handleToggle = (altstate) => {
        let _this = this

  
        if (altstate.alertValuesSet === false) {
            let detail = document.getElementById(altstate.alertId + "1")
            detail.style.display = "none"

            let edit = document.getElementById(altstate.alertId + "2")
            edit.style.display = "block"
            document.getElementById(altstate.alertId + "cancel").style.display = "block"
            document.getElementById(altstate.alertId + "edit").style.display = "none"

            let normaldiv = document.getElementById(altstate.alertId + "1")
            normaldiv.style.display = "none"
            let loaderdiv = document.getElementById(altstate.alertId + "2")
            loaderdiv.style.display = "block"

        }
        else {
            if (altstate.active === false) {

                let state = {
                    active: true,
                    alertEmailId: altstate.alertEmailId,
                    alertId: altstate.alertId,
                    alertName: altstate.alertName,
                    alertType: altstate.alertType,
                    alertValuesSet: altstate.alertValuesSet,
                    cardDetailsId: altstate.cardDetailsId,
                    contactNumber: altstate.contactNumber,
                    cutOverTime: altstate.cutOverTime,
                    merchantCategoryCodes: altstate.merchantCategoryCodes,
                    thresholdAmount: altstate.thresholdAmount,
                    thresholdType: altstate.thresholdType,
                    timezone: altstate.timezone,
                    useContactNumber: altstate.useContactNumber,
                    useMobilePush: altstate.useMobilePush
                }
                // var serv3 = ""
                // if (altstate.alertType === "DP") {
                //     serv3 = s.deb_txnpost_alert

                // }
                // else if (altstate.alertType === "CP") {
                //     serv3 = s.cdt_txnpost_alert

                // }
                // else if (altstate.alertType === "BT") {
                //     serv3 = s.card_bal_alert
                // }
                // else if (altstate.alertType === "NSF") {
                //     serv3 = s.insuf_bal_alert
                // }
                // else {
                //     serv3 = s.other_alert
                // }
                this.setState({
                    loader: true
                })
                // this.setState({
                //     cardBalanceLoader: true
                // })

                let token = "Token " + localStorage.getItem('token')

                fetch(s.other_alert, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });

                            this.setState({
                                loader: false
                            })
                            _this.props.fetchAlertState(altstate.cardDetailsId);

                        } else {

                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false
                            })

                        }
                    })

            }
            else {
                let state = {
                    active: false,
                    alertEmailId: altstate.alertEmailId,
                    alertId: altstate.alertId,
                    alertName: altstate.alertName,
                    alertType: altstate.alertType,
                    alertValuesSet: altstate.alertValuesSet,
                    cardDetailsId: altstate.cardDetailsId,
                    contactNumber: altstate.contactNumber,
                    cutOverTime: altstate.cutOverTime,
                    merchantCategoryCodes: altstate.merchantCategoryCodes,
                    thresholdAmount: altstate.thresholdAmount,
                    thresholdType: altstate.thresholdType,
                    timezone: altstate.timezone,
                    useContactNumber: altstate.useContactNumber,
                    useMobilePush: altstate.useMobilePush
                }

                // var serv4 = ""
                // if (altstate.alertType === "DP") {
                //     serv4 = s.deb_txnpost_alert

                // }
                // else if (altstate.alertType === "CP") {
                //     serv4 = s.cdt_txnpost_alert

                // }
                // else if (altstate.alertType === "BT") {
                //     serv4 = s.card_bal_alert
                // }
                // else if (altstate.alertType === "NSF") {
                //     serv4 = s.insuf_bal_alert
                // }
                // else {
                //     serv4 = s.other_alert
                // }
                this.setState({
                    loader: true
                })

                let token = "Token " + localStorage.getItem('token')
                fetch(s.other_alert, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false
                            })

                            _this.props.fetchAlertState(altstate.cardDetailsId);
                        } else {

                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });


                        }
                    })


            }

        }
    }
    handleSelect1 = (event, index, value) => {

        const { cardState } = this.props
        for (let i = 0; i < cardState.body.length; i++) {
            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i]
                })
            }
        }
        
        let _this = this

        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {
                   
                    this.setState({
                        
                        selectedCard: cardState.body[i]
                    }, () => {
                        _this.setState({
                            loader: true
                        })
                        setTimeout(function () {
                        _this.props.fetchAlertState(cardState.body[i].cardDetailsId)
                        },500)

                    })
                }
            }
        });

    }
    componentWillReceiveProps(nextProps) {
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,
                    selectedCard: nextProps.cardState.body[0]
                }, () => {
                   
                })
            }
        } catch (e) {

        }

    }


    render() {
        const { alertState, cardState } = this.props
        const { alertEmailId, thresholdAmount, selectedCard, cardDetailsId, correctamount, correctEmail,eventId,eventId2 } = this.state
       
        const borderRadiusStyle = { borderRadius: 2 }

        return (

            <div className="col-md-12 " style={{ padding: "0px 30px" }}>
                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?
                    <div className="row">
                        <div className="col-md-12 nopadding">

                            <div className="col-md-12 nopadding">
                                <div className="row">
                                    <div className="col-md-3" style={{ marginTop: "6px", marginLeft: "40px" }}>
                                        <span style={{ fontSize: "17px", fontWeight: "600", color: "#585555" }}>
                                            {selectedCard.cardProgramId}
                                        </span>
                                    </div>
                                    <div className="offset-md-1 col-md-7 text-right pull-right">
                                        <div className="row">
                                            <div className="col-md-4 input-icon" >
                                                <label style={{ fontWeight: "bold", color: "#585555", marginTop: "8px" }}>Card Number : </label>
                                            </div>
                                            <div className="col-md-8" >
                                                <SelectField
                                                    floatingLabelText=""
                                                    onChange={this.handleSelect1}
                                                    className="input-width"
                                                    name="Selected Card"
                                                    style={{ marginTop: -12 }}
                                                    value={cardDetailsId}>
                                                    {cardState.body.map((value, i) =>
                                                        <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                    )}
                                                </SelectField>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-12 nopadding">


                            {this.state.loader ? <div><LoaderSmall /></div> :
                                alertState.status === 200 && alertState.body.length !== 0 ?
                                    alertState.body.map((value, i) =>
                                        <div className="col-xs-12 nopadding" key={i}>
                                            <div className="tile box-shadow-style">
                                                <div className="row">
                                                    <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                                        <div className="summary-header">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <p>{alertState.body[i].alertName}</p>
                                                                </div>

                                                                <div className="col-sm-1" id={alertState.body[i].alertId + "loaderdiv"} style={{ marginTop: "0px" }}  >

                                                                </div>
                                                                <div className="col-md-1 text-left tilepadding" style={{ marginLeft: "60px" }}>
                                                                    <ToggleButton
                                                                        value={alertState.body[i].active}
                                                                        thumbStyle={borderRadiusStyle}
                                                                        trackStyle={borderRadiusStyle}
                                                                        onToggle={(e) => { this.handleToggle(alertState.body[i]) }}
                                                                    />
                                                                </div>

                                                                <div className="col-md-2 text-right" id={alertState.body[i].alertId + "edit"} style={{ padding: "0px" }}>
                                                                    <span style={{ cursor: "pointer" }} onClick={(e) => { this.handleBasic(alertState.body[i]) }}><i className="fa fa-pencil-square-o" aria-hidden="true"></i>Edit</span>
                                                                </div>
                                                                <div className="col-md-2 text-right" id={alertState.body[i].alertId + "cancel"} style={{ padding: "0px", display: "none" }}>
                                                                    <span style={{ cursor: "pointer" }} onClick={(e) => { this.handleCancel(alertState.body[i].alertId) }}><i className="fa fa-times" aria-hidden="true"></i>Cancel</span>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    {(alertState.body[i].alertType === "BT") ?
                                                                        <span>Scheduled alert triggered whenever frequency of alert is met containing the balance snapshot at current time.</span>
                                                                        :
                                                                        (alertState.body[i].alertType === "AC") ?
                                                                            <span>Triggered whenever Card is closed in system.</span>
                                                                            :
                                                                            (alertState.body[i].alertType === "CP") ?
                                                                                <span>
                                                                                    You will receive an alert when an amount below or above a specified limit is posted to your card account.</span>
                                                                                :
                                                                                (alertState.body[i].alertType === "DP") ?
                                                                                    <span>
                                                                                        You will receive an alert when an amount below or above a specified limit is deducted from your card account.
                                                                                        </span>
                                                                                    :
                                                                                    (alertState.body[i].alertType === "DPA") ?
                                                                                        <span>
                                                                                            Triggered whenever any pre-auth transaction declined due to any reason.
                                                                                        </span>
                                                                                        :
                                                                                        (alertState.body[i].alertType === "NSF") ?
                                                                                            <span>
                                                                                                You will receive an alert when a transaction is declined due to insufficient balance on your card account.
                                                                                        </span>
                                                                                            :
                                                                                            (alertState.body[i].alertType === "ITA") ?
                                                                                                <span>
                                                                                                    Triggered whenever an international transaction is processed.
                                                                                        </span>
                                                                                                :
                                                                                                (alertState.body[i].alertType === "PC") ?
                                                                                                    <span>

                                                                                                        Triggered whenever cardholder password change event occurred in system.
                                                                                                     </span>
                                                                                                    :
                                                                                                    (alertState.body[i].alertType === "UP") ?
                                                                                                        <span>

                                                                                                            Triggered whenever cardholder profile is updated in system.
                                                                                                           </span>
                                                                                                        :
                                                                                                        (alertState.body[i].alertType === "PDCL") ?
                                                                                                            <span>


                                                                                                                You will receive an alert when an invalid PIN attempt is made.
                                                                                                                   </span>
                                                                                                            :
                                                                                                            <span>You will receive an alert when an amount below or above a specified limit is deducted from your card account.</span>
                                                                    }
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* display details */}
                                                    <div className="col-sm-12" style={{ marginTop: "20px" }} id={alertState.body[i].alertId + "1"}>
                                                        <div className="row">
                                                            <div className="col-md-2 tilepadding text-right">
                                                                <label className="tilecontent">Email :</label>
                                                            </div>
                                                            <div className="col-md-4 text-left tilepadding">
                                                                <span className="tileheadername">{alertState.body[i].alertEmailId}</span><br />
                                                            </div>
                                                            {(alertState.body[i].alertType === "BT" || alertState.body[i].alertType === "CP" || alertState.body[i].alertType === "DP" || alertState.body[i].alertType === "ITA") ?
                                                                <div className="col-md-6 nopadding ">
                                                                    <div className="row">
                                                                        {(alertState.body[i].thresholdType !== null) ?
                                                                            (alertState.body[i].thresholdType === "G") ?
                                                                                <div className="col-md-6 text-left tilepadding">
                                                                                    <span className="tileheadername">Greater than or equals</span><br />
                                                                                </div>
                                                                                :
                                                                                <div className="col-md-6 text-left tilepadding">
                                                                                    <span className="tileheadername">Less than or equals</span><br />
                                                                                </div>
                                                                            :
                                                                            <div>
                                                                            </div>
                                                                        }

                                                                        <div className="col-md-6 text-left tilepadding">
                                                                            <span className="tileheadername">{alertState.body[i].currencySymbol} {alertState.body[i].thresholdAmount}</span><br />
                                                                        </div>
                                                                    </div>
                                                                </div> :
                                                                <div>
                                                                </div>
                                                            }

                                                        </div>
                                                    </div>


                                                    {/* edit details */}


                                                    <div className="col-lg-12 editmodal" id={alertState.body[i].alertId + "2"} style={{ display: "none" }}>
                                                        <div className="row">
                                                            {alertState.body[i].alertEmailId &&
                                                                <div className="col-sm-4" >
                                                                    <TextField
                                                                        hintText="Email"
                                                                        id={alertState.body[i].alertType}
                                                                        floatingLabelText="Email"
                                                                        type="text"
                                                                        defaultValue={alertState.body[i].alertEmailId}
                                                                        maxLength="50"
                                                                        name="alertEmailId"
                                                                        className="input-width"
                                                                        onChange={this.onchangeEmail}
                                                                        underlineFocusStyle={styles.focusStyle}
                                                                        floatingLabelFocusStyle={styles.focusTextStyle}
                                                                        errorText={(alertState.body[i].alertType === eventId)? correctEmail ? null : "Not a valid email" :""} />
                                                                </div>
                                                            }

                                                            {(alertState.body[i].alertType === "BT" || alertState.body[i].alertType === "CP" || alertState.body[i].alertType === "DP" || alertState.body[i].alertType === "ITA") ?

                                                                <div className="col-sm-8 nopadding">
                                                                    <div className="row">

                                                                        <div className="col-sm-6" style={{ marginTop: "12px" }}>
                                                                            <SelectField
                                                                                floatingLabelText="Criteria"
                                                                                onChange={this.handleChange}
                                                                                className="input-width"
                                                                                name="thresholdType"
                                                                                style={{ marginTop: -12 }}

                                                                                value={this.state.thresholdType || alertState.body[i].thresholdType}>

                                                                                <MenuItem value="G" primaryText="Greater than or equals" />
                                                                                <MenuItem value="L" primaryText="Less than or equals" />
                                                                            </SelectField>
                                                                        </div>

                                                                        <div className="col-sm-6" >
                                                                            <TextField
                                                                                hintText="Amount"
                                                                                floatingLabelText="Amount"
                                                                                id={alertState.body[i].alertType+"12"}
                                                                                defaultValue={alertState.body[i].thresholdAmount}
                                                                                onChange={this.onChangeAmount}
                                                                                name="thresholdAmount"
                                                                                className="input-width"
                                                                                maxLength="10"
                                                                                underlineFocusStyle={styles.focusStyle}
                                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                errorText={(alertState.body[i].alertType+"12" === eventId2)? correctamount ? null : "Amount with 2 decimal places is accepted" :""} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div>
                                                                </div>

                                                            }

                                                            <div className="offset-md-5 col-md-5 col-sm-5">
                                                                <div className="row input-group float-right" >
                                                                    <RaisedButton
                                                                        label="Save"
                                                                        onClick={(e) => { this.handleSubmit(alertState.body[i]) }}
                                                                        style={styles.button}
                                                                        backgroundColor="#333"
                                                                        labelColor="#fff"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    )


                                    :
                                    <h3 className="text-center">
                                        No Alerts found for this Card Number
                    </h3>
                            }

                        </div>
                    </div>
                    : <div style={{ marginTop: "200px" }}><LoaderSmall /></div>
                }
            </div>
            // <div className="col-xs-12 nopadding">
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Alert on specified Merchant Category</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>You will receive an alert when a transaction is carried out at the specified merchant location(s).</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.merchantAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     merchantAlert: !this.state.merchantAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //                 {/* <div className="row">
            //      <div className="col-md-3 tilepadding text-right">
            //          <label className="tilecontent">Mobile :</label>
            //      </div>
            //      <div className="col-md-6 text-left tilepadding">
            //          <span className="tileheadername">04 - 1694 -	1171</span><br />
            //      </div>
            //      <div className="col-md-3 text-left tilepadding">
            //          <ToggleButton
            //              value={this.state.merchantAlert2 || false}
            //              thumbStyle={borderRadiusStyle}
            //              trackStyle={borderRadiusStyle}
            //              onToggle={(value) => {
            //                  this.setState({
            //                      merchantAlert2: !this.state.merchantAlert2,
            //                  })
            //              }} />
            //      </div>
            //  </div> */}
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Card Activation Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Triggered whenever Card is activated in system</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.cardActAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     cardActAlert: !this.state.cardActAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Card Balance Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Scheduled alert triggered whenever frequency of alert is met containing the balance snapshot at current time.</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.cardBalanceAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     cardBalanceAlert: !this.state.cardBalanceAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Close Account Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Triggered whenever Card is closed in system</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.closeAccountAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     closeAccountAlert: !this.state.closeAccountAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Credit Transaction Posted</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>You will receive an alert when an amount below or above a specified limit is posted to your card account.</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.creditTrasAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     creditTrasAlert: !this.state.creditTrasAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>




            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Declined Pre-Authorization Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Triggered whenever any pre-auth transaction declined due to any reason.</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.declineAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     declineAlert: !this.state.declineAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Insufficient Funds on Card Account</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>You will receive an alert when a transaction is declined due to insufficient balance on your card account.</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.insuffFundAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     insuffFundAlert: !this.state.insuffFundAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>International Transaction Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Triggered whenever an international transaction is processed</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.internatinalAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     internatinalAlert: !this.state.internatinalAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Password Change Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Triggered whenever cardholder password change event occurred in system</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.passwordAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     passwordAlert: !this.state.passwordAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Update Profile Alert</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>Triggered whenever cardholder profile is updated in system</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.updateProfileAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     updateProfileAlert: !this.state.updateProfileAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            //     <div className="tile box-shadow-style">
            //         <div className="row">
            //             <div className="col-md-12" style={{ padding: "0px 15px" }}>
            //                 <div className="summary-header">
            //                     <div className="row">
            //                         <div className="col-md-12">
            //                             <p>Wrong PIN Attempt</p>
            //                         </div>
            //                         <div className="col-md-12">
            //                             <span>You will receive an alert when an invalid PIN attempt is made.</span>
            //                         </div>

            //                     </div>
            //                 </div>
            //             </div>
            //             <div className="col-sm-12" style={{ marginTop: "20px" }}>
            //                 <div className="row">
            //                     <div className="col-md-3 tilepadding text-right">
            //                         <label className="tilecontent">Email :</label>
            //                     </div>
            //                     <div className="col-md-6 text-left tilepadding">
            //                         <span className="tileheadername">kristy.allen@oxygen-global.com</span><br />
            //                     </div>
            //                     <div className="col-md-3 text-left tilepadding">
            //                         <ToggleButton
            //                             value={this.state.wrongPinAlert || false}
            //                             thumbStyle={borderRadiusStyle}
            //                             trackStyle={borderRadiusStyle}
            //                             onToggle={(value) => {
            //                                 this.setState({
            //                                     wrongPinAlert: !this.state.wrongPinAlert,
            //                                 })
            //                             }} />
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>

        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MangeAlert);






// WEBPACK FOOTER //
// ./src/components/myprofile/managealert.jsx